import { useEffect } from 'react'

/**
 * The face for the review variants. It is loaded only while a variant is on
 * screen and removed when it leaves, so the incumbent page and every sub-page
 * keep the app's original font budget.
 */
export const PREVIEW_FONTS = {
  schibsted:
    'https://fonts.googleapis.com/css2?family=Schibsted+Grotesk:wght@400;500;600;700;800;900&display=swap',
} as const

export type PreviewFont = keyof typeof PREVIEW_FONTS

export function usePreviewFonts(fonts: PreviewFont[]) {
  const key = fonts.join('|')
  useEffect(() => {
    const created: HTMLLinkElement[] = []
    key
      .split('|')
      .filter(Boolean)
      .forEach((name) => {
        const href = PREVIEW_FONTS[name as PreviewFont]
        if (href == null) return
        if (document.head.querySelector(`link[data-rda-font="${name}"]`)) return
        const el = document.createElement('link')
        el.rel = 'stylesheet'
        el.href = href
        el.setAttribute('data-rda-font', name)
        document.head.appendChild(el)
        created.push(el)
      })
    return () => {
      created.forEach((el) => el.remove())
    }
  }, [key])
}
